import { RightChevronIcon } from '@_shared/icons';
import { Typography } from '@_shared/ui/Typography';

import * as S from './SettingGroup.style';

interface IProps {
	children: React.ReactNode;
}

interface ISettingItemProps extends IProps {
	onClick: () => void;
	isToggleUI: boolean;
	isActive?: boolean;
}

export function Container({ children }: IProps) {
	return <S.Container>{children}</S.Container>;
}

export function SettingGroupHeader({ children }: IProps) {
	return (
		<Typography type="title-large" color="font-primary">
			{children}
		</Typography>
	);
}

export function SettingList({ children }: IProps) {
	return <S.List>{children}</S.List>;
}

export function SettingItem({ children, isToggleUI, isActive, onClick }: ISettingItemProps) {
	return (
		<S.SettingItemContainer onClick={onClick}>
			<Typography type="body-large" color="font-secondary">
				{children}
			</Typography>
			{isToggleUI ? (
				<S.ToggleSwitchWrapper>
					<S.ToggleSwitch isActive={!!isActive}>
						<div />
					</S.ToggleSwitch>
				</S.ToggleSwitchWrapper>
			) : (
				<S.SettingItemLinkIcon>
					<RightChevronIcon />
				</S.SettingItemLinkIcon>
			)}
		</S.SettingItemContainer>
	);
}
